import { render, staticRenderFns } from "./ModalConfirmarExcluir.vue?vue&type=template&id=456ff2f0&lang=pug"
import script from "./ModalConfirmarExcluir.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarExcluir.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarExcluir.vue?vue&type=style&index=0&id=456ff2f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports